module.exports = __webpack_public_path__ + "img/logo-verano-cinepolis.81a5599b.png";